var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-[25%] bg-white dark:bg-slate-900 contact--panel"},[_c('campaign-msg-info',{attrs:{"show-close-button":_vm.showCloseButton,"campaign-msg":_vm.campaignMsg,"close-icon-name":"dismiss"},on:{"panel-close":_vm.onClose,"toggle-panel":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }